import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const RegionStepConfig: StepConfig = {
    type: FormType.REGION
};
